export const companyTagGroup = {
  IMPORTANT_INFO: "Důležité info",
  LANGUAGES: "Jazyky",
  CONTACT_TYPES: "Typy kontaktů",
  TREATMENT_STATE: "Stav léčby",
};

export const insurance = {
  111: "111 - VZP",
  201: "201 - VOZP",
  205: "205 - CPZP",
  207: "207 - OZP",
  209: "209 - ZPS",
  211: "211 - ZMMV",
  213: "213 - RBP",
  301: "301 - Cigna",
  333: "333 - PVZP",
  555: "555 - SV",
  666: "666 - Uniqa",
  777: "777 - Slavia",
  888: "888 - Maxima",
};

export function getForeignSpeakingOnlyTitle(client) {
  const language = client?.prefs?.language;
  const languages = new Set(
    (client?.languageInfoTags ?? []).map((t) => t.value),
  );

  if (
    (languages.size === 0 && language == null) ||
    (language === "čeština" && languages.size === 0) ||
    languages.has("čeština") ||
    languages.has("slovenština")
  ) {
    return null;
  }

  return Array.from(new Set([...languages, language]))
    .filter((v) => v != null && v.trim() !== "")
    .filter((v) => v !== "čeština" && v !== "slovenština")
    .sort()
    .join(", ");
}

export function canBeTreated(client) {
  return client?.blocker == null;
}

export function blockerText(client) {
  const texts = client.blockers?.map((b) => b.text) ?? [];
  const blocker = client.blocker ? `Blocker: ${client.blocker}` : null;
  const text = [blocker, ...texts].filter((t) => t != null).join("\n");

  if (text.length === 0) {
    return null;
  }

  return text;
}

export function hasBlocker(client) {
  return blockerText(client) != null;
}
